import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b156aa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product product-card" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "product__heading" }
const _hoisted_4 = { class: "product-card__body" }
const _hoisted_5 = { class: "product-card__info" }
const _hoisted_6 = { class: "rating" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-star rating__icon" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "rating__value" }
const _hoisted_9 = { class: "price" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "price__actual" }
const _hoisted_13 = { class: "price__fixed" }
const _hoisted_14 = {
  key: 0,
  class: "icon-cart-plus cart-btn__icon"
}
const _hoisted_15 = {
  key: 1,
  class: "icon-cart-ok cart-btn__icon"
}

import { IProduct } from '@/services';
import { useProductInfo } from '@/composables';
import { computed } from 'vue';
import { RouteNames } from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardItem',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: IProduct;
};



const { inCart, toggleProduct } = useProductInfo(props.product);

const cartBtnClass = computed(() => {
  return inCart.value ? 'cart-btn_in-cart' : '';
});

function cartBtnClick(e: Event) {
  e.preventDefault();
  toggleProduct();
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: { name: _unref(RouteNames).product, params: { id: `${__props.product.id}` } },
      class: "a product-card__head"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "product__image",
          src: __props.product.thumbnail,
          loading: "lazy"
        }, null, 8 /* PROPS */, _hoisted_2),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.product.title), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(__props.product.rating), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (__props.product.discountPercentage === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, " $" + _toDisplayString(__props.product.actualPrice.toFixed(2)), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, "$" + _toDisplayString(__props.product.actualPrice.toFixed(2)), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_13, "$" + _toDisplayString(__props.product.price.toFixed(2)), 1 /* TEXT */)
              ]))
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["btn cart-btn product-card__cart-btn", _unref(cartBtnClass)]),
        onClick: cartBtnClick
      }, [
        (!_unref(inCart))
          ? (_openBlock(), _createElementBlock("i", _hoisted_14))
          : (_openBlock(), _createElementBlock("i", _hoisted_15))
      ], 2 /* CLASS */)
    ])
  ]))
}
}

})